<template>

    <div class="my-6">
        <label for="comment" class="block text-sm font-medium text-gray-700"></label>

        <div class="my-3">
            <ListBoxSelectWithImage labelMain="Material Type" :options="typeMaterialSheetMetal"
                v-model="form.typeMaterialSheetMetal" requires="True" />
        </div>

        <div class="my-3">
            <ListBoxSelectWithImage v-if="form.typeMaterialSheetMetal == 'Aluminum'" labelMain="Material Thickness"
                :options="typeMaterialSheetMetalAluminum" v-model="form.typeMaterialSheetMetalSize" requires="True" />

            <ListBoxSelectWithImage v-if="form.typeMaterialSheetMetal == 'Cold Rolled Steel'"
                labelMain="Material Thickness" :options="typeMaterialSheetMetalColdRolledSteel"
                v-model="form.typeMaterialSheetMetalSize" requires="True" />

            <ListBoxSelectWithImage v-if="form.typeMaterialSheetMetal == 'Stainless Steel'"
                labelMain="Material Thickness" :options="typeMaterialSheetMetalStainlessSteel"
                v-model="form.typeMaterialSheetMetalSize" requires="True" />

            <ListBoxSelectWithImage v-if="form.typeMaterialSheetMetal == 'Galvanneal'" labelMain="Material Thickness"
                :options="typeMaterialSheetMetalGalvanneal" v-model="form.typeMaterialSheetMetalSize" requires="True" />

            <ListBoxSelectWithImage v-if="form.typeMaterialSheetMetal == 'Copper'" labelMain="Material Thickness"
                :options="typeMaterialSheetMetalCopper" v-model="form.typeMaterialSheetMetalSize" requires="True" />
        </div>

        <div v-if="form.typeMaterialSheetMetal == 'Other'">
            <BaseTextArea
                label="Please tell us about the material you require. We can source material as a non-stock request, for additional leadtime and cost."
                v-model="form.typeMaterialSheetMetalOther"
                tooltip="We can source different material as a non-stock request, for additional leadtime and cost." />

        </div>

        <div class="my-3">


            <ListBoxSelectWithImage :options="typeMaterialFinish" v-model="form.typeMaterial" labelMain="Finish Type"
                requires="True" />

            <ListBoxSelectWithImage v-if="form.typeMaterial == `Bare-Metal Finish`"
                :options="typeMaterialFinishBareMetal" v-model="form.typeMaterialFinishType" />

            <ListBoxSelectWithImage v-if="form.typeMaterial == `Powdercoat Finish`"
                :options="typeMaterialFinishPowderCoat" v-model="form.typeMaterialFinishType"
                placeholder="Select Option" />

            <BaseInput v-if="form.typeMaterialFinishType == 'Other'"
                label="Please indicate the powdercoat color you require"
                placeholder="Please indicate the powdercoat color you require" v-model="form.otherPowderCoat" />
        </div>

        
        <div v-if="form.typeMaterial == `Bare-Metal Finish`" class="my-3">

            <label v-if="form.typeMaterialSheetMetal == 'Aluminum' || form.typeMaterialSheetMetal == 'Stainless Steel'" for="comment" class="block text-sm font-medium text-gray-700"> Additional Finish Type </label>

            <div v-if="form.typeMaterialSheetMetal == 'Aluminum'">
                <input type="checkbox" value="Chemical Conversion Coating" id="Chemical Conversion Coating"
                    class="h-4 w-4 mx-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                    v-model="form.typeMaterialFinishAdditionAluminum" />
                <label for="Chemical Conversion Coating">Chemical Conversion Coating</label>
                <input type="checkbox" value="Anodizing" id="Anodizing"
                    v-model="form.typeMaterialFinishAdditionAluminum"
                    class="h-4 w-4 mx-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500" />
                <label for="Anodizing">Anodizing</label>
            </div>

            <!-- stainless steel finish type starts here -->
            <div v-if="form.typeMaterialSheetMetal == 'Stainless Steel'">
                <input type="checkbox" value="Passivation" id="Passivation"
                    class="h-4 w-4 mx-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                    v-model="form.typeMaterialFinishAdditionStainlessSteel" />
                <label for="Passivation">Passivation</label>

            </div>

            <!-- stainless steel finish type ends here -->


        </div>
        <div class="my-3">
            <BaseRadioButtonGroup :options="yesNo" group="`requireWelding`" v-model="form.NewDesignSheetMetalWelding"
                label="Does your design require welding?" requires="True" />

            <BaseRadioButtonGroup :options="yesNo" group="`requireGraphics`" v-model="form.DoYouRequireGrpahics"
                label="Do you require graphics?" requires="True" />

            <div v-if="form.DoYouRequireGrpahics == 'Yes'">
                <BaseRadioButtonGroup :options="reqGraphics" group="`typeOfGraphics`" v-model="form.reqGraphics"
                    label="Which type of graphics do you require? " requires="True" />
                <!-- If graphics is required starts -->
                <BaseRadioButtonGroup
                    v-if="(form.reqGraphics == 'Quote for Both' || form.reqGraphics == 'Digital Print')"
                    :options="digitalPrint" v-model="form.NewDesignSheetMetalDigitalPrint"
                    label="Which type of digital print do you require?" requires="True" />
                <!-- If graphics is required ends -->

            </div>

            <!-- hide when form.typeMaterialSheetMetal is Cold Rolled Steel -->
            <div v-if="form.typeMaterialSheetMetal != 'Cold Rolled Steel'">
                <BaseRadioButtonGroup :options="reqPermanentMarking" v-model="form.reqPermanentMarking"
                    label="Does your design require Permanent Marking? " requires="True" />

                <!-- If permanent marking is required starts  -->
                <div v-if="form.reqPermanentMarking == 'Yes'">
                    <!-- when typeMaterialSheetMetal is Aluminium show Permananent Marking options as "Laser Marking, Dot Peening, Engrave and Fill, Quote All Options" -->
                    <div v-if="form.typeMaterialSheetMetal == 'Aluminum'">
                        <BaseRadioButtonGroup :options="typePermanentMarkingAluminium"
                            v-model="form.NewDesignSheetMetalPermanentMarking"
                            label="Which permanent marking are you looking for? " requires="True" />
                    </div>
                    <!-- when typeMaterialSheetMetal is Stainless Steel show Permananent Marking options as "Laser Marking, Dot Peening, Quote All Options" -->
                    <div v-if="form.typeMaterialSheetMetal == 'Stainless Steel'">
                        <BaseRadioButtonGroup :options="typePermanentMarkingStainlessSteel"
                            v-model="form.NewDesignSheetMetalPermanentMarking"
                            label="Which permanent marking are you looking for? " requires="True" />
                    </div>
                    <!-- when typeMaterialSheetMetal is Galvanneal and Copper show Permananent Marking options as "Dot Peening" -->
                    <div v-if="form.typeMaterialSheetMetal == 'Galvanneal' || form.typeMaterialSheetMetal == 'Copper'">
                        <BaseRadioButtonGroup :options="typePermanentMarkingOther"
                            v-model="form.NewDesignSheetMetalPermanentMarking"
                            label="Which permanent marking are you looking for? " requires="True" />
                    </div>


                </div>
                <!-- If permanent marking is required ends -->

                <div
                    v-if="(form.NewDesignSheetMetalPermanentMarking == 'Laser Marking' || form.NewDesignSheetMetalPermanentMarking == 'Quote all options')">
                    <label class="block text-sm font-medium text-gray-700"> Which types of Laser Marking do you want
                        quoted?</label>
                    <div class="origin-center flex my-2">
                        <div v-if="form.typeMaterialSheetMetal == 'Aluminum'">
                            <input type="checkbox" value="Engrave" id="Engrave"
                                class="h-4 w-4 mx-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                v-model="form.LaserMarkingSheetMetal" />
                            <label for="Engrave">Engrave</label>
                        </div>
                        <div v-if="form.typeMaterialSheetMetal == 'Aluminum'">
                            <input type="checkbox" value="Burn" id="Burn"
                                class="h-4 w-4 mx-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                v-model="form.LaserMarkingSheetMetal" />
                            <label for="Burn">Burn</label>
                        </div>
                        <div v-if="form.typeMaterialSheetMetal == 'Aluminum'">
                            <input type="checkbox" value="Silver" id="Silver"
                                class="h-4 w-4 mx-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                v-model="form.LaserMarkingSheetMetal" />
                            <label for="Silver">Silver</label>
                        </div>
                        <div v-if="form.typeMaterialSheetMetal == 'Aluminum'">
                            <input type="checkbox" value="Outline" id="Outline"
                                class="h-4 w-4 mx-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                v-model="form.LaserMarkingSheetMetal" />
                            <label for="Outline">Outline</label>
                        </div>
                        <div v-if="form.typeMaterialSheetMetal == 'Aluminum'">
                            <input type="checkbox" value="Ablate" id="Ablate"
                                class="h-4 w-4 mx-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                v-model="form.LaserMarkingSheetMetal" />
                            <label for="Ablate">Ablate</label>
                        </div>
                        <div v-if="form.typeMaterialSheetMetal == 'Stainless Steel'">
                            <input type="checkbox" value="Anneal" id="Anneal"
                                class="h-4 w-4 mx-2 rounded border-gray-300 text-blue-600 focus:ring-blue-500"
                                v-model="form.LaserMarkingSheetMetal" />
                            <label for="Anneal">Anneal</label>
                        </div>
                    </div>
                </div>
            </div>
            

            <!-- If permanent marking is required ends -->


            <BaseRadioButtonGroup v-if="(form.reqPermanentMarking == 'Yes' || form.reqGraphics == 'Yes')"
                :options="yesNo" :group="`artwork`" label="Is your artwork finalized?"
                v-model="form.artworkFinalized" />
            <div v-if="form.artworkFinalized == 'Yes'" class="my-6">
                <div class="space-y-6  sm:space-y-5 ">
                    <FileComponent @uploaded="handleFileUpload" />
                </div>
            </div>

            <BaseRadioButtonGroup v-if="form.fileCad == 'Yes'" :options="yesNo" :group="`generateTemplateCAD`"
                label="Did you generate a CAD template from our Template Generator to create your design?"
                v-model="form.usedProtocaseDesigner" />


        </div>

    </div>

</template>

<script setup>
import { inject } from 'vue';

import {
    typeMaterialSheetMetal,
    typeMaterialSheetMetalAluminum,
    typeMaterialSheetMetalColdRolledSteel,
    typeMaterialSheetMetalGalvanneal,
    typeMaterialSheetMetalStainlessSteel,
    typeMaterialSheetMetalCopper,


} from '../../constants/sheetMetal';

import { materialFinishOptionsByType, typeMaterialFinish, typeMaterialFinishBareMetal, typeMaterialFinishPowderCoat, typeMaterialAluminumOnly, typeMaterialStainlessSteelOnly, typeMaterialCopperOnly } from '../../constants/finish';
import BaseRadioButtonGroup from '../formComponents/BaseRadioButtonGroup.vue';
import BaseInput from '../formComponents/BaseInput.vue';
import BaseSelect from '../formComponents/BaseSelect.vue';
import ListBoxSelectWithImage from '../formComponents/ListBoxSelectWithImage.vue';
import FileComponent from '../formComponents/FileComponent.vue';
import BaseTextArea from '../formComponents/BaseTextArea.vue';

const form = inject('form');

// file upload and store file data as JSON
const handleFileUpload = (file) => {
    form.artworkFinalizedSheetMetal = file;
    form.artworkFinalizedSheetMetalfileName = file.name;
}

form.typeMaterialFinishAdditionAluminum = [];

const yesNo = [
    { 'title': 'Yes', id: true },
    { 'title': 'No', id: false },
]

const typePermanentMarkingAluminium = [
    { 'title': 'Laser Marking', 'id': 'Laser Marking', "group": 'graphics' },
    { 'title': 'Dot Peening', 'id': 'Dot Peening', "group": 'graphics' },
    { 'title': 'Engrave and Fill', 'id': 'Engrave and Fill', "group": 'graphics' },
    { 'title': 'Quote all options', 'id': 'Quote all options', "group": 'graphics' }
]

const typePermanentMarkingStainlessSteel = [
    { 'title': 'Laser Marking', 'id': 'Laser Marking', "group": 'graphics' },
    { 'title': 'Dot Peening', 'id': 'Dot Peening', "group": 'graphics' },
    { 'title': 'Quote all options', 'id': 'Quote all options', "group": 'graphics' }
]

const typePermanentMarkingOther = [
    { 'title': 'Dot Peening', 'id': 'Dot Peening', "group": 'graphics' },
]



const reqGraphics = [
    { 'title': 'Digital Print', "id": 'Digital Print' },
    { 'title': 'Silkscreen', "id": 'Silkscreen' },
    { 'title': 'Quote for Both', "id": 'Quote for Both' },
]
const reqPermanentMarking = [
    { 'title': 'Yes', 'id': 'Yes', "group": 'reqPermanentMarking' },
    { 'title': 'No', 'id': 'No', "group": 'reqPermanentMarking' },
]

const digitalPrint = [
    { 'title': 'Standard Resolution (720 dpi)', 'id': 'Standard Resolution (720 dpi)', "group": 'digitalPrint' },
    { 'title': 'Premium Resolution (1440 dpi)', 'id': 'Premium Resolution (1440 dpi)', "group": 'digitalPrint' },
    { 'title': 'Quote for Both', 'id': 'Quote for Both', "group": 'digitalPrint' },
]






</script>